module.exports = __webpack_public_path__ + "static/2p-3-71f5e28df79744c3ec511eb644c4c3a2.jpeg";